import { authAPI } from '@/providers/apis/auth/auth';
import { sessionService } from '@/providers/services/auth/session';
import router from '@/routers/router';
import access from '@/permission/permission';

export class AuthService {
  private static INSTANCE = new AuthService();

  static get instance() {
    return this.INSTANCE;
  }

  public checkAuthentication() {
    const sessionModel = sessionService.getSession();
    const urlParams = new URLSearchParams(document.location.search);
    const nonceToken = urlParams.get('nonce');
    if (sessionModel === null && !nonceToken) {
      if (router.currentRoute.path !== '/login') {
        router.push('/login');
      }
    }
  }

  public async loginBasedOnAccessToken(query: any) {
    return access.loginBasedOnToken(query.access_token as any, query);
  }

}

export const authService = AuthService.instance;
